import { render, staticRenderFns } from "./ForProductsPage.vue?vue&type=template&id=46c94aac&scoped=true"
import script from "./ForProductsPage.vue?vue&type=script&lang=js"
export * from "./ForProductsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c94aac",
  null
  
)

export default component.exports